module.exports = __webpack_public_path__ + "static/media/unispace-life-sciences.e76e6d4d.png";